import type { CSSProperties, ReactNode } from 'react'
import { Icon } from '@/features/gate/v1/kit'
import type { V1IconName } from '@/features/gate/v1/sprite'

/**
 * The godown boards' icons the gate sprite does not carry, drawn inline in the same stroke style
 * (24×24, currentColor, round caps) and copied from the alignment map's sprite.
 */
const EXTRA = {
  godown: (
    <>
      <path d="M3 9l9-5 9 5v11H3z" />
      <path d="M7 20v-7h10v7M7 16.5h10" />
    </>
  ),
  shield: <path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z" />,
  plus: <path d="M12 5v14M5 12h14" />,
  list: (
    <>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <circle cx="4.5" cy="6" r="1" />
      <circle cx="4.5" cy="12" r="1" />
      <circle cx="4.5" cy="18" r="1" />
    </>
  ),
  problembag: (
    <>
      <path d="M6 8h12l1 12H5z" />
      <path d="M6 8L4.5 5M18 8l1.5-3" />
      <path d="M10 8l2-3 2 3" />
      <path d="M12 11.5v4.5M12 18.3v.01" />
    </>
  ),
  sign: (
    <>
      <path d="M3 20c3-1 5-6 7-6s0 4 2 4 3-3 5-3 3 2 4 2" />
      <path d="M14 4l4 4-6 6-4 0 0-4z" />
    </>
  ),
  file: (
    <>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M14 3v5h5" />
    </>
  ),
} satisfies Record<string, ReactNode>

export type StoreIconName = V1IconName | keyof typeof EXTRA

/** A V1 icon: the gate sprite's, or one of the godown boards' own. */
export function SIcon({
  name,
  size = 24,
  sw = 2,
  style,
}: {
  name: StoreIconName
  size?: number
  sw?: number
  style?: CSSProperties
}) {
  if (!(name in EXTRA)) return <Icon name={name as V1IconName} size={size} sw={sw} style={style} />
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0, ...style }}
    >
      {EXTRA[name as keyof typeof EXTRA]}
    </svg>
  )
}
